// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class HistoryDepthLimit {
    constructor(ticks, minBars, dayBars) {
        this.ticks = ticks;
        this.minBars = minBars;
        this.dayBars = dayBars;
    }
}
